import { format, subMonths } from 'date-fns';

import { ANALYTICS_DATE_FORMAT } from '../../constants/dateFormats';
import { alertError } from './alert';
import { REPORTS_MANAGER_DATA, REPORTS_MANAGER_LOADING } from '../reducers/reportsManager';
import api, { isResponseOk } from '../../utils/api';

export const getReports = () => async (dispatch, getState) => {
  dispatch({ type: REPORTS_MANAGER_LOADING, payload: { loading: true } });

  const state = getState();
  const { supplierId } = state.role;

  const params = getReportsManagerParamsFromState({ state });

  try {
    const response = await postGetReports({ supplierId, params });
    if (!isResponseOk(response)) {
      dispatch(alertError(new Error(`Couldn't get reports`)));
      return;
    }

    const data = response.data.reports || [];
    const totalCount = response.data.totalCount || 0;

    dispatch({
      type: REPORTS_MANAGER_DATA,
      payload: {
        data,
        totalCount,
      },
    });
  } catch (error) {
    dispatch(alertError(error));
  } finally {
    dispatch({ type: REPORTS_MANAGER_LOADING, payload: { loading: false } });
  }
};

export function getReportsManagerParamsFromState({ state }) {
  const {
    filters: {
      dates: { start, end },
      type,
      status,
    },
    table: {
      pagination: { page, rowsPerPage },
      sort: { column, direction },
    },
  } = state.reportsManager;

  const params = {
    startDate: format(start ?? subMonths(new Date(), 1), ANALYTICS_DATE_FORMAT),
    endDate: format(end ?? new Date(), ANALYTICS_DATE_FORMAT),
    types: type,
    statuses: status,
    page,
    rowsPerPage,
    sortColumn: column,
    sortDirection: direction,
  };

  return params;
}

export async function postGetReports({ supplierId, params }) {
  const url = `/suppliers/${supplierId}/report-manager`;
  return api.post(url, params);
}
